import { render, staticRenderFns } from "./UpdateOrder.vue?vue&type=template&id=f3751326&scoped=true&"
import script from "./UpdateOrder.vue?vue&type=script&lang=js&"
export * from "./UpdateOrder.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrder.vue?vue&type=style&index=0&id=f3751326&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3751326",
  null
  
)

export default component.exports